/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetAllPositionsStatus200, GetAllPositionsStatus500 } from '../types/GetAllPositions'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getAllPositions } from '../clients/getAllPositions'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getAllPositionsQueryKey = () => [{ url: '/v1/ledger/positions' }] as const

type GetAllPositionsQueryKey = ReturnType<typeof getAllPositionsQueryKey>

export function getAllPositionsQueryOptions(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getAllPositionsQueryKey()
  return queryOptions<
    GetAllPositionsStatus200,
    ResponseErrorConfig<GetAllPositionsStatus500>,
    GetAllPositionsStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getAllPositions({
        ...config,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get all users' positions
 * {@link /v1/ledger/positions}
 */
export function useGetAllPositions<
  TData = GetAllPositionsStatus200,
  TQueryData = GetAllPositionsStatus200,
  TQueryKey extends QueryKey = GetAllPositionsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetAllPositionsStatus200,
        ResponseErrorConfig<GetAllPositionsStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getAllPositionsQueryKey()

  const queryResult = useQuery(
    {
      ...getAllPositionsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetAllPositionsStatus500>> & {
    queryKey: TQueryKey
  }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
